<template>
  <div class="rtc-container">
    <!-- 三合一 四个人 -->
    <!-- <el-button class="button" type="primary" size="small" :disabled="isJoining || isJoined" @click="handleJoinRoom">{{ $t('Join Room') }}</el-button> -->
    <!-- 进房操作区域
    <p v-if="isHostMode" class="label">{{ $t('Operation') }}</p>
    <div class="control-container">
      <div class="rtc-control-container">
        进入房间
        <el-button class="button" type="primary" size="small" :disabled="isJoining || isJoined" @click="handleJoinRoom">{{ $t('Join Room') }}</el-button>
        <el-button v-if="isHostMode" class="button" type="primary" size="small" :disabled="isPublishing || isPublished" @click="handlePublish">{{ $t('Publish') }}</el-button>
        <el-button v-if="isHostMode" class="button" type="primary" size="small" @click="handleUnpublish">{{ $t('Unpublish') }}</el-button>
        离开房间
        <el-button class="button" type="primary" size="small" @click="handleLeave">{{ $t('Leave Room') }}</el-button>
      </div>
      远程控制
      <div v-if="isHostMode" class="screen-share-control-container">
        <el-button class="button" type="primary" size="small" :disabled="isShareJoined && isSharePublished" @click="handleStartScreenShare">{{ $t('Start Screen Share') }}</el-button>
        <el-button class="button" type="primary" size="small" @click="handleStopScreenShare">{{ $t('Stop Screen Share') }}</el-button>
      </div>
    </div> -->
    <!-- 显示邀请链接 -->
    <!-- <div v-if="showInviteLink" class="invite-link-container">
      <span v-if="isEnLang">Copy the link to invite friends to join the video call, one link can invite only one person,
        the link will be updated automatically after copying.</span>
      <span v-else>复制链接邀请好友加入视频通话，一条链接仅可邀请一人，复制后自动更新链接。</span>
      <el-input class="invite-input" v-model="inviteLink">
        <template slot="prepend">
          <el-tooltip :visibleArrow="false" effect="dark" content="Copied!" placement="bottom" :manual="true" v-model="showCopiedTip">
            <span class="invite-btn" @click="handleCopyInviteLink">
              <svg-icon icon-name="copy"></svg-icon>
            </span>
          </el-tooltip>
        </template>
      </el-input>
    </div> -->
    <div class="info-container" :class="$isMobile && 'info-container-mobile'">
      <!-- Log 展示区域 -->
      <!-- v-if="localStream" -->
      <!-- 本地流区域 -->
      <div class="local-stream-container">

        <!-- 远端流区域  yuanduan-->
        <div class="remote-container ">
          <!-- 现在需要解决的是  占位问题  -->
          <!-- remoteStreamList" :key="item.getUserId()" :id="item.getUserId() -->
          <div v-for="(item) in remoteStreamList" :key="item.getUserId()" :id="item.getUserId()" class=" remote-stream-container">
            <!-- <div class="videname" v-if="item">
              {{ item.getUserId() }}
            </div> -->
            <template v-if="item">
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.community_doctor.member_id ">{{ VideoUserinfo.community_doctor.name}}--{{ item.getUserId() }}</div>
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.doctor1.member_id ">{{ VideoUserinfo.doctor1.name}}--{{ item.getUserId() }}</div>
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.doctor2.member_id ">{{ VideoUserinfo.doctor2.name}}--{{ item.getUserId() }}</div>
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.doctor3.member_id ">{{ VideoUserinfo.doctor3.name}}--{{ item.getUserId() }}</div>
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.member.member_id ">{{ VideoUserinfo.member.name}}--{{ item.getUserId() }}</div>
              <div class="videname" v-if="item.getUserId() == VideoUserinfo.my.member_id ">{{ VideoUserinfo.my.name}}--{{ item.getUserId() }}</div>
            </template>

          </div>
          <!-- 本地流播放区域 local-stream-content  v-if="localStream"-->
          <div id="localStream" class="remote-stream-container" v-if="localStream">

            <div class="videname">{{  VideoUserinfo.my.name }}</div>
          </div>
        </div>

        <!-- 本地流操作栏 v-if="isPlayingLocalStream" -->
        <div class="local-stream-control" v-if="isPlayingLocalStream">
          <!-- 视频控制 -->
          <div class="one">
            <div class="video-control control">
              <div class="control_border" v-if="!isMutedVideo" @click="muteVideo">
                <img class="controller_img" src="../assets/images/camera-true.png" alt="">
              </div>
              <div class="control_border" v-if="isMutedVideo" @click="unmuteVideo">
                <img class="controller_img" src="../assets/images/camera-false.png" alt="">
              </div>
            </div>
            <!-- 声音控制 -->
            <div class="audio-control control">
              <div class="control_border" v-if="!isMutedAudio" @click="muteAudio">
                <img class="controller_img" src="../assets/images/speaker-true.png" alt="">
              </div>
              <div class="control_border" v-if="isMutedAudio" @click="unmuteAudio">
                <img class="controller_img" src="../assets/images/speaker-false.png" alt="">
              </div>
            </div>
            <!--摄像头前后切换 -->
            <div class="audio-control control">
              <div class="control_border">
                <img class=" controller_img" @click="toggleCreamer" src="../assets/images/switch.png" alt="">
              </div>
            </div>
          </div>
          <!-- 挂断 -->
          <div class="tow">
            <div class="audio-control control  guaduan" @click="handleLeave">
              <div class="control_border">
                <img class="controller_img" src="../assets/images/hangup-red.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="loading">
      <img src="../assets/images/loading.png" alt="">
    </div>

  </div>
</template>

<script>
import { Loading, Message } from "element-ui";

import rtc from "./mixins/rtc.js";
import TRTC from "trtc-js-sdk";
import shareRtc from "./mixins/share-rtc.js";
import LibGenerateTestUserSig from "@/utils/lib-generate-test-usersig.min.js";
export default {
  name: "compRoom",
  mixins: [rtc, shareRtc],
  props: {
    type: String,
    // sdkAppId: Number,
    // secretKey: String,
    userId: String,
    roomId: Number,
    cameraId: String,
    microphoneId: String,
    inviteUserSig: String,
  },
  data() {
    return {
      currentVideo: true,
      logList: [],
      inviteLink: "",
      showCopiedTip: false,
      sdkAppId: 1600046669,
      secretKey:
        "2410e5aa62212da01721ced52a4f3308d5a64b2232c1a88eb0e4063315dcb63f",
      userId: "",
      roomId: 9999, // 会议ID
      isCreamer: false,
      loading: null,
      seatArr: [], // 占位
      end_time: 0,
      showToast: false,
      Ismessage: false,
      timer: null,
      VideoUserinfo: {},
    };
  },
  created() {
    let url = window.location.href; //获取当前url
    let params = {};
    let str = url.split("?")[1];
    let obj = {};
    if (str) {
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        // params[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
        obj = JSON.parse(decodeURIComponent(strs[i].split("=")[1]));
      }
    }
    console.log(obj, "obj");

    this.userId = obj.userId || "99999";
    this.roomId = Number(obj.roomId) || 8888;
    this.end_time = obj.end_time; // 结束时间
    this.VideoUserinfo = obj;
    // localStorage.setItem("muitipleInfo", JSON.stringify(obj));

    // params.order_id

    // alert(params.roomId);   需要传过来所有的信息 然后展示  根据id 展示
  },
  computed: {
    isHostMode() {
      return this.type !== "invite";
    },
    isEnLang() {
      return this.$i18n.locale === "en";
    },
    showInviteLink() {
      return (
        this.isHostMode &&
        (this.isJoined || this.isShareJoined) &&
        this.inviteLink
      );
    },
  },
  watch: {
    cameraId(val) {
      this.switchDevice("video", val);
    },
    microphoneId(val) {
      this.switchDevice("audio", val);
    },
    isPlayingLocalStream(val) {
      if (val == true) {
        // this.loading.close();
      }
    },
  },
  mounted() {
    this.handleJoinRoom();
    this.timer = setInterval(() => {
      this.getCurrentTimer();
    }, 2000);
  },
  methods: {
    getCurrentTimer() {
      let currentTimer = new Date(Date.now()).getTime();
      let shengyu = this.end_time - Number(currentTimer);
      if (shengyu <= 600000 && shengyu >= 500000 && !this.showToast) {
        this.showToast = true;
        Message({
          showClose: true,
          message: "会议于10分钟后结束",
          type: "error",
        });
        // uni.showToast({
        //   title: "会议于10分钟后结束",
        //   duration: 5000,
        // });
      }
      if (currentTimer > this.end_time && !this.Ismessage) {
        this.Ismessage = true;
        let that = this;
        Message({
          showClose: true,
          message: "当前会议已到期",
          type: "error",
        });
        setTimeout(() => {
          that.handleLeave();
        }, 3000);
        // uni.showModal({
        //   title: "提示",
        //   content: "当前会议已到期",
        //   success(res) {
        //     if (res.confirm) {
        //       that.handleLeave();
        //     } else if (res.cancel) {
        //       that.handleLeave();
        //     }
        //   },
        // });
      }
    },
    generateInviteLink() {
      if (!this.isHostMode) {
        return;
      }
      const { sdkAppId, secretKey, roomId } = this;
      const inviteUserId = `user_${parseInt(Math.random() * 100000000, 10)}`;
      const userSigGenerator = new LibGenerateTestUserSig(
        sdkAppId,
        secretKey,
        604800
      );
      const inviteUserSig = userSigGenerator.genTestUserSig(inviteUserId);
      this.inviteLink = encodeURI(
        `${location.origin}${location.pathname}#/invite?sdkAppId=${sdkAppId}&userSig=${inviteUserSig}&roomId=${roomId}&userId=${inviteUserId}`
      );
    },
    handleCopyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink);
      this.showCopiedTip = true;
      setTimeout(() => {
        this.showCopiedTip = false;
      }, 1500);
      this.generateInviteLink();
    },
    // 点击【Join Room】按钮
    async handleJoinRoom() {
      if (this.isHostMode) {
        if (!this.sdkAppId || !this.secretKey) {
          alert(this.$t("Please enter sdkAppId and secretKey"));
          return;
        }
        if (!this.userId || !this.roomId) {
          alert(this.$t("Please enter userId and roomId"));
          return;
        }
        const userSigGenerator = new LibGenerateTestUserSig(
          this.sdkAppId,
          this.secretKey,
          604800
        );
        this.userSig = userSigGenerator.genTestUserSig(this.userId);
      } else {
        if (
          !this.sdkAppId ||
          !this.inviteUserSig ||
          !this.userId ||
          !this.roomId
        ) {
          alert(this.$t("Please reacquire the invitation link"));
          return;
        }
        this.userSig = this.inviteUserSig;
      }
      await this.initClient();
      await this.join();
      await this.initLocalStream();
      await this.playLocalStream();
      await this.publish();
      this.generateInviteLink();
    },
    // 切换播放区域
    toggleContainer() {},

    // 切换摄像头
    async toggleCreamer() {
      this.isCreamer = !this.isCreamer;
      let that = this;
      TRTC.getCameras().then((devices) => {
        if (this.isCreamer) {
          that.switchDevice("video", devices[0].deviceId);
        } else {
          that.switchDevice("video", devices[1].deviceId);
        }
      });
    },
    // 点击【Publish】按钮
    async handlePublish() {
      await this.publish();
    },

    // 点击【Unpublish】按钮
    async handleUnpublish() {
      await this.unPublish();
    },

    // 点击【Leave Room】按钮
    async handleLeave() {
      await this.leave();
      uni.navigateBack();
    },

    // 点击【开始屏幕分享】按钮
    async handleStartScreenShare() {
      if (!this.sdkAppId || !this.secretKey) {
        alert(this.$t("Please enter sdkAppId and secretKey"));
        return;
      }
      await this.initShareClient();
      await this.initShareLocalStream();
      await this.handleShareJoin();
      await this.handleSharePublish();
      this.generateInviteLink();
    },

    // 点击【停止屏幕分享按钮】
    async handleStopScreenShare() {
      await this.handleShareUnpublish();
      await this.handleShareLeave();
    },

    // 显示成功的 Log
    addSuccessLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "success",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },

    // 显示失败的 Log
    addFailedLog(log) {
      if (!this.isHostMode) {
        return;
      }
      this.logList.push({
        type: "failed",
        log,
      });
      // const { scrollHeight } = this.$refs.logContainer;
      // this.$refs.logContainer.scrollTop = scrollHeight;
    },
    reportSuccessEvent(name) {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-success`,
        ext2: "webrtcQuickDemoVue2",
        ext3: this.sdkAppId,
      });
    },
    reportFailedEvent(name, error, type = "rtc") {
      this.$aegis.reportEvent({
        name,
        ext1: `${name}-failed#${this.roomId}*${
          type === "share" ? this.shareUserId : this.userId
        }*${error.message}`,
        ext2: "webrtcQuickDemoVue2",
        ext3: this.sdkAppId,
      });
    },
  },
  beforeDestroy() {
    //  清除定时器
    clearIntervalt(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
// 页面最外面的容器
.rtc-container {
  width: 100%;
  height: 100%;
  min-height: 100vh;

  overflow: hidden;
  .label {
    margin: 14px 0 6px;
    text-align: left;
    font-weight: bold;
  }
  .control-container {
    text-align: left;
    margin-bottom: 10px;
    div:not(:nth-last-child(1)) {
      margin-bottom: 10px;
    }
    .button:not(:first-child) {
      margin-left: 2px;
    }
  }
  .invite-link-container {
    width: 100%;
    color: #084298;
    background-color: #cfe2ff;
    position: relative;
    padding: 10px 16px;
    margin-bottom: 16px;
    border: 1px solid #b6d4fe;
    border-radius: 0.25rem;
    .invite-input {
      margin-top: 10px;
    }
    .invite-btn {
      display: flex;
      cursor: pointer;
    }
  }
  .info-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    .log-container {
      flex-grow: 1;
      border: 1px solid #dddddd;
      height: 360px;
      padding: 10px;
      margin-right: 16px;
      overflow-y: scroll;
      .log-label {
        margin: 0 0 6px;
        font-weight: bold;
      }
      .log-state {
        display: inline-block;
        margin-right: 6px;
      }
      > div {
        font-size: 12px;
      }
    }
    // 播放容器
    .local-stream-container {
      // background-color: #ccc;
      width: 100%;
      min-height: 100vh;
      height: 100%;
      position: relative;
      flex-shrink: 0;
      // 本地播放的容器
      .local-stream-content {
      }
      // 控制器操作栏
      .local-stream-control {
        width: 100%;
        height: 160px;
        position: absolute;
        z-index: 999;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
        padding: 0 10px;
        .one {
          margin-top: 20px;
          display: flex;
          justify-content: space-around;
        }
        .tow {
          margin-top: 20px;
          display: flex;
          align-content: center;
          justify-content: center;
        }
        .control_border {
          padding: 10px;
          background-color: #fff;
          border-radius: 50%;

          .controller_img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
        }

        .control {
          margin-left: 10px;
        }
        .icon-class {
          color: #fff;
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      }
    }
  }

  .info-container-mobile {
    display: block;
    .log-container {
      margin-right: 0;
    }
  }
  // 远端流主容器
  .remote-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    // min-height: 100vh;
    // padding: 2%;
    display: flex;
    flex-wrap: wrap;

    align-items: flex-start;
    align-content: flex-start; // 加了我就可以了
    // flex-direction: column;
    // justify-content: space-between;
    // align-items: flex-start;
    .remote-stream-container {
      position: relative;
      // width: 50%;
      // height: 50%;
      flex-shrink: 0; /* 防止项目缩小 */
      width: 49%;
      height: 40%;
      // height: 400px;
      margin: 0.5%;
      background-color: #000 !important;
      .videname {
        position: absolute;
        bottom: 3%;
        left: 3%;
        color: #fb5531;
        z-index: 99;
      }
    }
  }
}
.minBox {
  width: 100%;
  height: 40%;
}
.maxBox {
  width: 100% !important;
  min-height: 100vh !important;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 98;
}
.yuanduan {
  position: absolute;
  right: 0%;
  top: 2%;
  background-color: #fff !important;
  z-index: 989;
}
.loading {
}
</style>

<i18n>
{
	"en": {
		"Operation": "Operation",
    "Join Room": "Join Room",
    "Publish": "Publish",
    "Unpublish": "Unpublish",
    "Leave Room": "Leave Room",
    "Start Screen Share": "Start Screen Share",
    "Stop Screen Share": "Stop Screen Share",
    "Please enter sdkAppId and secretKey": "Please enter sdkAppId and secretKey",
    "Please enter userId and roomId": "Please enter userId and roomId",
    "Please reacquire the invitation link": "Please reacquire the invitation link!"
	},
	"zh": {
		"Operation": "操作",
    "Join Room": "进入房间",
    "Publish": "发布流",
    "Unpublish": "取消发布流",
    "Leave Room": "离开房间",
    "Start Screen Share": "开始共享屏幕",
    "Stop Screen Share": "停止共享屏幕",
    "Please enter sdkAppId and secretKey": "请输入 sdkAppId 和 secretKey",
    "Please enter userId and roomId": "请输入 userId 和 roomId",
    "Please reacquire the invitation link": "请重新获取邀请链接！"
	}
}
</i18n>
